import React from 'react';

import { KeyValue } from 'components/KeyValue';
import * as Types from 'types';

type Props = {
  editions: Types.Edition[];
  user: Types.User;
};

export const EditionsStats: React.FC<Props> = ({ editions, user }) => {
  return (
    <div className='row d-none d-sm-flex'>
      <div className='col-auto mb-1'>
        <KeyValue keyLabel='Owned Editions'>{editions.length}</KeyValue>
      </div>
      <div className='col-auto mb-1'>
        <KeyValue keyLabel='Collection Rank'>{user.rank}</KeyValue>
      </div>
    </div>
  );
};
